<div class="forwarding-dashboard">
  <h1 class="title">{{ 'admin.forwarding.title' | localize }}</h1>

  @if (loading) {
    <div class="has-text-centered p-5">
      <span class="loader"></span>
      <p>{{ 'admin.forwarding.loading' | localize }}</p>
    </div>
  } @else {
    @if (error) {
      <div class="notification is-danger">
        {{ error }}
      </div>
    }

    @if (successMessage) {
      <div class="notification is-success">
        {{ successMessage }}
      </div>
    }

    @if (stats) {
      <h2 class="subtitle">{{ 'admin.forwarding.queueStats' | localize }}</h2>

      <div class="columns">
        <div class="column is-half">
          <div class="box has-text-centered">
            <p class="heading">{{ 'admin.forwarding.pending' | localize }}</p>
            <p class="title">{{ stats.pendingCount }}</p>
          </div>
        </div>
        <div class="column is-half">
          <div class="box has-text-centered">
            <p class="heading">{{ 'admin.forwarding.failed' | localize }}</p>
            <p class="title">{{ stats.failedCount }}</p>
          </div>
        </div>
      </div>

      <div class="buttons">
        <button class="button is-warning" (click)="onRetryFailed()" [disabled]="actionInProgress">
          @if (actionInProgress) {
            <span class="loader is-loading mr-2"></span>
          }
          {{ 'admin.forwarding.retryFailed' | localize }}
        </button>
        <button class="button is-primary" (click)="onProcessQueue()" [disabled]="actionInProgress">
          @if (actionInProgress) {
            <span class="loader is-loading mr-2"></span>
          }
          {{ 'admin.forwarding.processQueue' | localize }}
        </button>
      </div>
    }
  }
</div>
